import { Component, Input, HostListener, ElementRef } from '@angular/core';

@Component({
    selector: 'labels-list',
    templateUrl: './labels-list.component.html',
    styleUrls: ['./labels-list.component.scss']
})
export class LabelsListComponent {

    /**
     * Array of objects
     * with label name property
     */
    @Input() labelsList: object[];

    /**
     * Object property name
     * that contains label name value
     */
    @Input() keyName: string = 'name';

    isShowAllLabels = false;

    constructor(private _eref: ElementRef) {}

    toggle(event: Event) {
        event.stopPropagation(); // to prevent sidebar open/close
        this.isShowAllLabels = !this.isShowAllLabels;
    }

    @HostListener('document:click', ['$event.target'])
    private hide(targetElement: HTMLElement): void {
        if (!this._eref.nativeElement.contains(targetElement)) {
            this.isShowAllLabels = false;
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/labels-list/labels-list.component.ts